/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdCheckTagGroupProps, TdCheckTagProps, TdTagProps } from './type';

export const tagDefaultProps: TdTagProps = {
  closable: false,
  disabled: false,
  icon: undefined,
  shape: 'square',
  size: 'medium',
  theme: 'default',
  variant: 'dark',
};

export const checkTagDefaultProps: TdCheckTagProps = { disabled: false, size: 'medium' };

export const checkTagGroupDefaultProps: TdCheckTagGroupProps = { multiple: false, defaultValue: [] };
